$(function() {

    var $document = $(document);

//    const api = Cookies.withAttributes({ path: '/', sameSite: 'strict', secure: true })

    var trip_items_list = [];
    var trip_items_data = [];

    var utils = {

        'cookieTest': function() {

            try {
              // Create cookie
              document.cookie = 'cookietest=1; SameSite=None; Secure';
              var ret = document.cookie.indexOf('cookietest=') != -1;
              // Delete cookie
              document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=None; Secure';
              return ret;
            }
            catch (e) {
              return false;
            }

        },

        'cookieSetup': function() {

            var currentCookie = Cookies.get('trip_items');
            if (!currentCookie) {
                Cookies.set('trip_items', utils.generateUUID());
            }

        },

    };

    var tripApp = {

        'init': function() {
    /*
            var output = [];
            var outputObjs = {};

            var len = output.length;
            for (var i=0;i<len;i++) {
                outputObjs[output[i]] = constants[output[i]];
            }
            utils.putOutputs(prefix_display, outputObjs);
    */
//            hashCheck();

            var cookie_items = Cookies.get('trip_items');
            if (cookie_items) {
                trip_items_list = cookie_items.split(',');
            }
            tripApp.loadItems();

        },

        'updateCounter': function() {
            var tripCount = trip_items_list.length;
            $('.tripCount').text(tripCount);
            if (tripCount > 0) {
                $('#myTripListClear').show();
            } else {
                $('#myTripListClear').hide();
            }
        },

        'updateLinks': function() {
            $('.addTripItem').removeClass('added');
            for (key in trip_items_list) {
                $('.addTripItem[data-item-id="'+trip_items_list[key]+'"]').addClass('added');
            }
        },

        'updateItems': function() {
            $('.listTripItem').each(function() {
                var key = $(this).attr('data-item-id');
                if ($.inArray(key, trip_items_list) === -1) {
                    $(this).remove();
                }
            });
            if ($('.listTripItem').length < 1) {
                $('#tripItemsEmpty').removeClass('hide');
            }
        },

        'addItem': function(key) {
            if ($.inArray(key, trip_items_list) === -1) {
                trip_items_list.push(key);
                tripApp.saveItems();
            }
        },

        'addItems': function(ids) {
            var keys = ids.split(',');
            for (key in keys) {
                if ($.inArray(keys[key], trip_items_list) === -1) {
                    trip_items_list.push(keys[key]);
                }
            }
            tripApp.saveItems();
        },

        'removeItem': function(key) {
            if ($.inArray(key, trip_items_list) > -1) {
                var itemId = trip_items_list[key];
                trip_items_list = trip_items_list.filter(function(itemkey) {
                    return itemkey !== key
                });
                tripApp.saveItems();
            }
        },

        'clearItems': function(key) {
            trip_items_list = [];
            trip_items_data = [];
            tripApp.saveItems();
        },

        'saveItems': function() {
            if (trip_items_list.length > 0) {
                var cookie_items = [];
                for (key in trip_items_list) {
                    cookie_items.push(trip_items_list[key]);
                }
                Cookies.set('trip_items', cookie_items.join());
            } else {
                Cookies.remove('trip_items');
            }
            tripApp.loadItems();
        },

        'loadItems': function() {
            trip_items_data = [];
            var trip_json = {};
            var trip_query = trip_items_list.join();
            if (trip_query !== '') {
                var jqxhr = $.getJSON('/directory-items/list.json?ids='+trip_query, function(tripData) {
                    trip_json = tripData.data;
                    $.each(trip_json, function(key, obj) {
                        trip_items_data.push(obj);
                    });
                    tripApp.outputItems();
                });
            } else {
                tripApp.outputItems();
            }
        },

        'outputItems': function() {
            var html = '';
            if (Object.keys(trip_items_data).length > 0) {
                for (key in trip_items_data) {
                    var trip_item = trip_items_data[key];
                    html += '<li><a href="javascript.void(0);" class="removeTripItem float-right" data-item-id="'+trip_item.id+'" alt="Remove">X</a><a href="'+trip_item.url+'" class="itemDetails" data-item-id="'+trip_item.id+'">'+trip_item.title+'</a></li>';
                }
                $('#myTripListPrint').removeClass('hide');
            } else {
                $('#myTripListPrint').addClass('hide');
            }
            $('#myTripListNav').html(html);
            tripApp.updateCounter();
            tripApp.updateLinks();
            tripApp.updateItems();
        }

    };

    $document.on('click', '.addTripItem', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var id = $(this).attr('data-item-id');
        if ($.inArray(id, trip_items_list) === -1) {
            tripApp.addItem(id);
        } else {
            tripApp.removeItem(id);
        }
    });

    $document.on('click', '.addTripItems', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var ids = $(this).attr('data-item-ids');
        tripApp.addItems(ids);
    });

    $document.on('click', '.removeTripItem', function(e) {
        e.preventDefault();
        var id = $(this).attr('data-item-id');
        tripApp.removeItem(id);
    });

    $document.on('click', '.clearTripItems', function(e) {
        e.preventDefault();
        tripApp.clearItems();
    });

    tripApp.init();

});
